
(function () {

  'use strict';

  /**
   * @author Frank Song
   * @ngdoc filter
   * @description wrapper filter for telephone numbers
   * @name uteTfnFormatter
   * @class ute-ui
   * @memberOf ute-ui
   */
  angular.module('ute.ui')

    .filter('uteTfnFormatter', function () {

      return function (data) {

        var firstDigit = '';

        data = '' + data;

        data = data.replace(/[^\d]/g, '');

        if (data.match(/\d{10,11}/g)) {

          if (data.length === 11) {
            firstDigit = data.substr(0, 1) + ' ';
            data = data.substr(1);
          }

          data = firstDigit + data.substr(0, 3) + ' ' + data.substr(3, 3) + '-' + data.substr(6);

        } else {

          throw new Error("The telephone number is not valid: " + data);

        }

        return data;

      };

    });

})();

(function () {

  'use strict';

  /**
   * @author Frank Song
   * @ngdoc directive
   * @description format telephone in the format [1] (647) 862-7810
   * @name uteTfn
   * @class ute-ui
   * @memberOf ute-ui
   */

  angular.module('ute.ui')

    .directive('uteTfn', ['$filter', function ($filter) {
      return {
        restrict: 'E',
        scope: {
          callLink: '@',
          data: '@'
        },
        link: function ($scope, $element, $attrs) {


          var oldNumber,
            callLink,
            newNumber;

          $attrs.$observe('data', function(newVal, oldVal) {

            if (newVal) {

              oldNumber = newVal.replace(/[^\d]/g, '');

              /* jshint ignore:start */
              callLink = typeof $attrs.callLink === 'string' ? (eval($attrs.callLink)) : $attrs.callLink;
              /* jshint ignore:end */

              newNumber = $filter('uteTfnFormatter')(oldNumber);

              $element.empty();

              if (!callLink) {

                $element.append(newNumber);

              } else {

                $element.append('<a href="tel:' + oldNumber + '" class="ute-link">' + newNumber + '</a>');

              }

            }

          });

        }

      };

    }]);

})()
